<template v-if="product">

    <PantalladeCarga v-if="creandoPDF == true" titulo="Creando Presupuesto PDF..."></PantalladeCarga>



        <!-- Producto para Escritorio -->

        <div class="card card-lg shadow-lg desktop-only" style="border:1px solid #bdbdbd; margin-bottom:15px;">
            
            <div class="card-header text-left row">

                <div class="col-2 imagen-compania">

                    <img :src="urlImages+'/'+product.image" style="max-width: 150px; padding: 10px; "/>

                </div>

                <div class="col-6">
                    <h3 class="card-title h6" style="padding-top:10px;" v-if="product.link"><b style="cursor:pointer;" @click="clickProducto(product.cod, product.price, 'info')">{{product.name}}</b></h3>
                    <h3 class="card-title h6" style="padding-top:10px;" v-else>{{product.name}}</h3>
                    <div class="card-text" style="padding-bottom: 10px; font: size 12pt; color:#000; font-style: italic;" v-html="product.description"></div>

                    <div class="card-body d-flex justify-content h-100 py-0" style="font-size:10pt;">

                        <ul class="list-checked list-checked-primary">
                            <li class="list-checked-item" style="color:red;" v-if="product.promotion && promocion"><b>PROMOCIÓN: <br>{{product.promotion}}</b></li>
                            <li class="list-checked-item" v-for="(feature, index2) in product.features" v-html="feature" :key="index2"></li>
                        </ul>
                    </div>

                </div>
            
                <div class="col-4 text-center">

                    <div class="mb-2" @click="clickProducto(product.cod, product.price, 'contratar')" style="cursor:pointer; padding-top:10px;">
                        <span class="display-2" :style="'color:'+colordeprecios+';'">{{Math.floor(product.price)}}</span>
                        <span class="fs-5" :style="'color:'+colordeprecios+';'">,{{((Math.floor(product.price)-product.price.toFixed(2))*(-100)).toFixed(0)}} </span>
                        <span :style="'color:'+colordeprecios+';'">{{product.currency}} {{product.period}}</span>
                    </div>

                    <div class="card-footer text-center">
                        <div class="d-grid mb-2">
                            <button @click="clickProducto(product.cod, product.price, 'contratar')" class="btn btn-warning" v-html="product.button"></button>
                        </div>
                        <div class="d-grid mb-2" style="padding-top:10px;" v-if="UrlDescargaPresupuesto">
                            <button @click="descargarPDF(product.cod, product.price)" class="btn btn-primary">Descargar Presupuesto 📄</button>
                        </div>

                        <div class="d-grid mb-2" style="padding-top:10px;" v-if="mostrarInfo == true">
                            <button @click="clickProducto(product.cod, product.price, 'info')" class="btn btn-primary">Más Información</button>
                        </div>

                    </div>

                </div>


            </div>

        </div>

        <!-- Producto para Escritorio -->



        <!-- Producto para Movil -->

        <div class="card card-lg shadow-lg mobile-only" style="border:1px solid #bdbdbd; margin-left: 15px; margin-right: 15px; margin-top:10px;">
            
            <div class="row ">

                <div class="col-4 text-center" style="padding:15px;">

                    <img :src="urlImages+'/'+product.image" style="max-width: 100px; padding: 10px; padding-bottom: 5px; text-align: center;"/>

                    <div @click="clickProducto(product.cod, product.price, 'none')" style="cursor:pointer;">
                        <span :style="'font-size: 28pt; color:'+colordeprecios+';'">{{Math.floor(product.price)}}</span>
                        <span :style="'font-size: 15pt;  color:'+colordeprecios+';'">,{{((Math.floor(product.price)-product.price.toFixed(2))*(-100)).toFixed(0)}} </span>
                        <span :style="'font-size: 10pt; color:'+colordeprecios+';'">{{product.currency}} {{product.period}}</span>
                    </div>

                </div>
            
                <div class="col-8 text-center" style="padding:15px">

                    <h3 class="card-title h6" style="padding-bottom:10px; padding-top:20px;" v-if="product.link"><b style="cursor:pointer;" @click="clickProducto(product.cod, product.price, 'info')">{{product.name}}</b></h3>
                    <h3 class="card-title h6" style="padding-bottom:10px; padding-top:20px;" v-else>{{product.name}}</h3>


                    

                    <div class="text-center">

                        <a :href="'tel:'+product.tel" v-if="product.tel">
                            <div class="text-center" style="padding:10px; width: 100%; cursor:pointer;">

                                <div class="text-center" style="max-width:190px; display:flex; margin: 0 auto; padding-bottom:10px;">
                                    <div class="col-2 text-right"><i class="bi bi-telephone custom-bg-primary text-white" style="padding:10px; border-radius:50%;"></i></div>
                                    <div class="col-10 text-left" style="font-size:13pt; margin-left:-10px;">{{product.tel}}</div>
                                    <div v-if="product.description" class="col-10 text-left" style="font-size:13pt; margin-left:-10px;" v-html="product.description"></div>

                                </div>

                            </div>
                        </a>

                        <div v-if="product.description" class="text-center" style="padding:10px; width: 100%; padding-top:0px; margin-top:-10px; font-style: italic; padding-bottom:20px;">


                            <div class="text-center" style="font-size:10pt; text-align: center;" v-html="product.description"></div>


                        </div>


                        <div class="d-grid">
                            <button @click="clickProducto(product.cod, product.price, 'contratar')" class="btn btn-warning" v-html="product.button"></button>
                        </div>

                        <div class="d-grid" style="padding-top:10px;" v-if="mostrarInfo == true">
                            <button @click="clickProducto(product.cod, product.price, 'info')" class="btn btn-primary">Más Información</button>
                        </div>

                    </div>
                </div>

            </div>

            <div class="row text-left">
                <div class="col-12 text-left" style="padding:15px;">

                <hr>

                <p class="text-left" v-if="mostrarDetalles==false" style="margin-left:25px; cursor:pointer;" @click="verDetalles(); clickProducto(product.cod, product.price, 'none');"><b><u>Ver Detalles</u></b></p>

                <p class="text-left" v-if="mostrarDetalles==true" style="margin-left:25px; cursor:pointer;" @click="ocultarDetalles(); clickProducto(product.cod, product.price, 'none');"><b><u>Ocutar Detalles</u></b></p>

                </div>

            </div>
            <div class="row text-left" v-if="mostrarDetalles==true">

                <div class="col-12 text-left" style="padding:15px;">

                        <ul class="list-checked list-checked-primary text-left">

                            <li class="list-checked-item" style="color:red;" v-if="product.promotion && promocion"><b>PROMOCIÓN: <br>{{product.promotion}}</b></li>
                            <li class="list-checked-item" v-for="(feature, index2) in product.features" v-html="feature" :key="index2"></li>
                        </ul>

                </div>

                <p class="text-left" v-if="mostrarDetalles==true" style="margin-left:25px; cursor:pointer;" @click="ocultarDetalles(); clickProducto(product.cod, product.price, 'none');"><b><u>Ocutar Detalles</u></b></p>



            </div>


            

        </div>

        <!-- Producto para Movil -->

        

</template>

<script>

import PantalladeCarga from '../PantalladeCarga.vue'


export default {
  name: 'Producto',
  components : {PantalladeCarga},
  emits: ["clickProducto"],
  props: {
    
    product: Object,
    quotation: Boolean,
    UrlDescargaPresupuesto: String,
    productoAnterior: Boolean,
    idPresupuesto: String,
    mostrarInfo: Boolean

  },

  data: function () {
    return {
    creandoPDF: false,
    colordeprecios: "#F78104",
    promocion: true,
    urlImages: "",
    mostrarDetalles : false
    }
  },

  mounted: async function(){


    if (ColorPrecios) {

        this.colordeprecios = ColorPrecios;

    }

    if (ActivatePromo) {

        if (ActivatePromo == "no")
        {
            this.promocion = false;

        } else {

            this.promocion = true;

        }

    } else {

        this.promocion = false;

    }

    if (urlImages) {

        this.urlImages = urlImages;

    } else {

        this.urlImages = "https://frontquery.github.io/DockerWordpressAlgoritmica/logos";


    }

  },

  methods: {


    clickProducto : async function(producto, price, tipo){

            
        await this.$emit("clickProducto", producto, price, tipo);


    },


    verDetalles : async function(){

        this.mostrarDetalles = true;

    },

    ocultarDetalles : async function(){

        this.mostrarDetalles = false;

    },

    descargarPDF : async function(producto, price){


        if (this.quotation == true)
        {
            
            this.creandoPDF = true;

            await this.clickProducto(producto, price, "download");

            await window.location.assign(this.UrlDescargaPresupuesto);

            this.creandoPDF = false;

        }

    }


  }

}
</script>


<style lang="scss" scoped>

    @media only screen and (max-width: 768px) {
        
        .display-1 {
            font-size:75pt;

        }

        .display-2 {
            font-size:75pt;

        }
        .preciosmoviles {

            margin-top:10px;
        }

        .desktop-only {

            display:none;

        }

        .mobile-only {

            display:block;

        }


    }

    @media only screen and (min-width: 768px) {


        .desktop-only {

            display:block;

        }

        .mobile-only {

            display:none;

        }

        .preciosmoviles {

            margin-left: 15px;
            margin-right: 15px;
            box-shadow: none;
            max-width: 500px;
        }

        .card-group-md-row {
            box-shadow: none;

        }

        .card-group-md-row {

            background: transparent;
            box-shadow: none;

        }


    }

    .badge {

        padding:10px;
        font-size: 10pt;
        margin:5px;
    }

    .semaforo {

        background: #E1E6EE;
        color: #000;

    }
    .imagen-compania {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .btn {

        font-size:10pt;

    }
</style>